import { UIIcon } from '../config/icons';
import { ABPaymentDialog } from '../lib/ab/payment';
import { ABScreen } from '../lib/ab/screen';
import { ABAvailabilityDots } from '../lib/ab/widgets-home';
import { aTrackClick, aTrackPage, aTrackShare } from '../lib/mdl/a-track';
import { CReviewHomeView } from '../lib/mdl/c-booking';
import { cBookingBuyMore, CBookingHomeView, cBookingsBook, cBookingsStandby } from '../lib/mdl/c-booking-home';
import { cEventTagName } from '../lib/mdl/c-event-tag';
import { cPlanDiscountedPrice } from '../lib/mdl/c-plan';
import { c_venues, cVenueDisplayName, cVenueGoogleMaps, CVenueSceneView, cVenueStaticMap } from '../lib/mdl/c-venue';
import { cVideoWatch } from '../lib/mdl/c-video-home';
import { the_links } from '../lib/mdl/f-links';
import { LegacyAvailability, LegacyCantBookReason, LegacyEvent, legacyEventByCityAndSlug, legacyEventGetAvailability, LegacyEventSession, legacyGetEventReviews, legacyIsSessionBookable, legacyPrettySessionTime } from '../lib/mdl/zzz-legacy-open-events';
import { meGetStatus } from '../lib/me/home';
import { the_login_scope, the_settings } from '../lib/me/login';
import { getCountry } from '../lib/me/me';
import { UIAside } from '../lib/ui/aside';
import { uiSetBG } from '../lib/ui/bg';
import { UIButton, UIButtonOnClickCallback } from '../lib/ui/component/button';
import { UIDialog } from '../lib/ui/component/dialog';
import { UIImageView } from '../lib/ui/component/image';
import { uiMarkdown } from '../lib/ui/component/markdown';
import { addTooltip } from '../lib/ui/component/tooltip';
import { showWarning } from '../lib/ui/component/warning';
import { $el } from '../lib/ui/elements';
import { uiIsMedia } from '../lib/ui/media';
import { $facebook } from '../lib/ui/media/facebook';
import { $soundcloud } from '../lib/ui/media/soundcloud';
import { $spotify } from '../lib/ui/media/spotify';
import { $twitter } from '../lib/ui/media/twitter';
import { $vimeo } from '../lib/ui/media/vimeo';
import { $youtube } from '../lib/ui/media/youtube';
import { UIScreen } from '../lib/ui/screen';
import { onScroll } from '../lib/ui/scroll';
import { uiSetTransition } from '../lib/ui/transition';
import { UIRelPos } from '../lib/ui/types';
import { UIView, UIViewAddSpec, UIViewSpec } from '../lib/ui/view';
import { $amount } from '../lib/y/amount';
import { $analytics } from '../lib/y/analytics';
import { xavis_experiments } from '../lib/y/debug';
import { $format } from '../lib/y/format';
import { $i18n, yGetI18N, yInterpolate } from '../lib/y/i18n';
import { $location } from '../lib/y/location';
import { $storage } from '../lib/y/storage';
import { $date, $time } from '../lib/y/time';
import { $id, YId, YObjectId } from '../lib/y/types';
import { yMakeMailtoLink } from '../lib/y/util';
import { HomeMenu } from './menu';

const tz = 'Europe/Stockholm';

export class HomeBookDialog extends UIDialog {
    constructor(event: LegacyEvent, venue: CVenueSceneView, session: LegacyEventSession, flow: string, availability: LegacyAvailability, booking?: CBookingHomeView) {
        super({ close: true, classes: 'm-mobile-fs m-550' });

        const max_amount = availability.max_book;
        const free_amount = availability.max_book_free;
        let amount: number;
        const instructions = yGetI18N(availability.instructions).split('\n').map(s => s.trim()).filter(s => s);

        const number = $el.SPAN('r-number');
        const price = $el.DIV('r-price');

        function _setAmount(new_amount: number) {
            if(new_amount < 1)
                new_amount = 1;
            else if(new_amount > max_amount)
                new_amount = max_amount;
            if(new_amount === amount) return;
            amount = new_amount;
            less.disabled = amount <= 1;
            more.disabled = amount >= max_amount;
            number.textContent = amount == 1 ? $i18n.tl.t_1_ticket : amount + ' ' + $i18n.tl.t_n_tickets;
            const extra = amount - free_amount;
            price.textContent = extra > 0 ? ((extra == 1 ? $i18n.tl.t_book_1_extra_ticket : (extra + ' ' + $i18n.tl.t_book_extra_tickets)) +
                ' á ' + $format.currency(availability.price) + ' = ' + $format.currency($amount.mul(availability.price, extra))) : '\u00a0';
        }

        const less = new UIButton({ kind: 'k-square', classes: 'm-round', icon: UIIcon.MINUS, on_click: () => { _setAmount(amount - 1) } });
        const more = new UIButton({ kind: 'k-square', classes: 'm-round', icon: UIIcon.PLUS, on_click: () => { _setAmount(amount + 1) } });

        _setAmount(free_amount);

        const end_unbook = event.getUnbookingEnd(session);

        this.content.ui_add([
            $el.DIV('w-block p-a-center', [
                $el.H2('title', event.name),
                $el.P('info', legacyPrettySessionTime(session), 'tl-time-or-place')
            ]),
            instructions.length > 0 && [
                $el.RULER(),
                $el.DIV('w-block p-a-center', [
                    $el.H4('heading', $i18n.tl.h_instructions),
                    $el.Ps('text', instructions),
                ]),
            ],
            $el.RULER(),
            $el.DIV('w-block l-form m-center', [
                $el.DIV('tl-amount-buttons', [less, number, more]),
                price,
                new UIButton({
                    title: $i18n.tl.b_confirm_booking, classes: 'ui-tint-reverse', on_click: () => {
                        const finalize = (model: CBookingHomeView, dialog?: UIDialog) => {
                            if(booking) {
                                Object.assign(booking, model);
                                $location.reload();
                            } else {
                                booking = model;
                                new HomeConfirmationDialog(booking, event, venue, session, flow).present({ replace: dialog });
                            }
                            dialog && dialog.dismiss(true);
                        };

                        const promise = booking ? cBookingBuyMore(booking.id, amount) : cBookingsBook($id.objectIdToId(session.id), amount);
                        return promise.then(r => {
                            if(r.data) {
                                finalize(r.data, this);
                            } else {
                                this.dismiss((new ABPaymentDialog(r.intent, { finish: finalize }, {})).present({ replace: this }));
                            }
                        })
                    }
                }),
                !booking && (end_unbook.is_future ? $el.DIV('r-conditions', $i18n.tl.t_book_free_unbook + ' ' + end_unbook.formatIn('EEE d MMM yyyy HH:mm', tz)) : // TODO: check what r-conditions does now
                    $el.DIV('r-conditions', [$i18n.tl.t_book_no_free_unbook + ' ', $el.A(the_links.unbooking, $i18n.tl.t_book_read_more)])),
                $el.DIV('r-conditions', [$i18n.tl.t_book_accept + ' ', $el.A(the_links.unbooking, $i18n.tl.t_book_conditions)])
            ])
        ])
    }
}

export class HomeConfirmationDialog extends UIDialog {
    constructor(booking: CBookingHomeView, event: LegacyEvent, venue: CVenueSceneView, session: LegacyEventSession, flow: string) {
        super({ close: true, classes: 'm-mobile-fs m-440 m-join-top' });
        $facebook.init();
        this.content.ui_add([
            event.model.pictures?.[0] && new UIImageView({ media: event.model.pictures[0] }, { classes: 'tl-dialog-top-image' }),
            $el.DIV('w-block p-a-center', [
                $el.H2('title', $i18n.tl.h_booking_confirmation),
                $el.P('text', $i18n.tl.t_booking_confirmation),
            ]),
            $el.RULER(),
            $el.DIV('w-block l-form m-center', [
                $el.H3('heading', event.name),
                $el.DIV('tl-time-or-place', [$el.ICON(UIIcon.CLOCK | UIIcon.WEIGHT_SOLID), legacyPrettySessionTime(session)]),
                $el.DIV('tl-time-or-place', [$el.ICON(UIIcon.LOCATION_DOT | UIIcon.WEIGHT_SOLID), venue.name]),
                $el.DIV('tl-red-number', booking.quantity + ' ' + $i18n.tl.t_n_tickets.toLocaleUpperCase()),
                $el.DIV('s-small'),
                $el.DIV('l-button-row', [
                    new UIButton({
                        left_icon: UIIcon.BRAND_FACEBOOK, classes: 'm-fb', title: $i18n.tl.b_share, on_click: () => {
                            aTrackShare('booking', 'facebook', { booking: booking.id, event: $id.objectIdToId(event.model.id), session: booking.session_id });
                            $analytics.track('Share booking', { booking_id: booking.id, event_id: event.model.id, event_name: event.name, media: 'Facebook', event_flow: flow });
                            $facebook.share(event.page_url + '?booked=true&utm_source=facebook&utm_medium=social&utm_campaign=booking_share');
                        }
                    }),
                    new UIButton({
                        title: $i18n.tl.b_see_booking, classes: 'ui-tint-reverse', right_icon: UIIcon.ARROW_RIGHT, on_click: () => {
                            $location.navigate(['booking', booking.part_id]);
                            this.dismiss(true);
                        }
                    })
                ])
            ]),
        ]);
    }
}

// export class HomeReserveDialog extends UIDialog
// {
//     constructor(booking: CBookingLegacyHomeView)
//     {
//          // TODO: fix for NewDialog
//         super({ close: true });
//         const content = this.content;

//         const email = new UITextInput({ type: 'email', placeholder: 'e-postadress', required: true });
//         const form = $form({ email: email });

//         const error_label = new TLErrorLabel;

//         const send = new UIButton({ title: $i18n.tl.b_reserve, on_click: () => {
//             if(!form.validate()) { return }

//             return $tl.actionReserve(booking.model.id, email.value).then(() => {
//                 this.dismiss(true);
//             }, message => {
//                 error_label.classList.remove('m-info');
//                 error_label.text = message; 
//             });
//         }});

//         content.add($el.DIV('w-block l-form m-center', [
//             $el.H2('title', $i18n.tl.h_reserve_dialog),
//             $el.P('info', $i18n.tl.t_reserve_dialog),
//             email,
//             $el.DIV('r-buttons', send),
//             error_label
//         ]));
//     }
// }

export function homeDisplayCantBookMessage(reason: LegacyCantBookReason, event_id?: YObjectId, availability?: LegacyAvailability, _schedule?: HomeSessionSchedule) {
    if(reason == 'cancelled') {
        showWarning({ text: 'Session has been cancelled', cancel_text: null });
    } else if(reason == 'no_subs') {
        $location.navigate(['subscribe'], { origin: 'direct', resubscribe: 'true' })

        // return meGetInfo('subscribe').then(info => {
        // if(info.payment_method) {
        //     new home_membership.ResubscribeDialog(info).present().then(() => { schedule && schedule.reload() });
        // } else {
        // $location.navigate(['subscribe'], { origin: 'direct', resubscribe: 'true' })
        // }
        // });
    } else if(reason == 'past_due') {
        showWarning({
            text: $i18n.tl.w_cantbook_pastdue,
            cancel_text: null, link_text: $i18n.tl.l_my_account,
            link_click: () => { $location.navigate(['membership']) }
        });
    } else if(reason == 'cancel_subs') {
        if(meGetStatus() == 'giftcard') {
            showWarning({
                text: $i18n.tl.w_cantbook_gc, cancel_text: null, link_text: $i18n.tl.l_my_account,
                link_click: () => { $location.navigate(['membership']) }
            });
        } else {
            showWarning({
                text: $i18n.tl.w_cantbook_cancel,
                cancel_text: null, link_text: $i18n.tl.l_my_account,
                link_click: () => { $location.navigate(['membership']) }
            });
        }
    } else if(reason == 'paused_subs') {
        showWarning({
            text: $i18n.tl.w_cantbook_paused,
            cancel_text: null, link_text: $i18n.tl.l_my_account,
            link_click: () => { $location.navigate(['membership']) }
        });
    } else if(reason == 'sales_ended') {
        showWarning({ text: $i18n.tl.w_cantbook_ended, cancel_text: null });
    } else if(reason == 'event_booking') {
        showWarning({ text: $i18n.tl.w_cantbook_already, cancel_text: null });
    } else if(reason == 'expired') {
        showWarning({ text: $i18n.tl.w_cantbook_expired, cancel_text: null });
    } else if(reason == 'past_booking') {
        showWarning({ texts: $i18n.tl.w_cantbook_been.split('\n'), cancel_text: null });
    } else if(reason == 'day_booking') {
        showWarning({ texts: $i18n.tl.w_cantbook_sameday.split('\n'), cancel_text: null });
    } else if(reason == 'two_bookings') {
        aTrackClick('book_limit', { event: $id.maybeObjectIdToId(event_id) });
        showWarning({
            texts: $i18n.tl.w_cantbook_limit.split('\n'), cancel_text: null,
            link_text: $i18n.tl.l_read_more_here, link_link: the_links.booking_limit
        });
    } else if(reason == 'no_tickets') {
        showWarning({ text: $i18n.tl.w_cantbook_notickets, cancel_text: null });
    } else if(reason == 'loyalty' || reason == 'loyalty_inactive' || reason == 'loyalty_paused') {
        showWarning({ text: yInterpolate(reason == 'loyalty' ? $i18n.tl.w_cantbook_loyalty : $i18n.tl.w_cantbook_loyalty_inactive, the_settings!.loyalty_months, availability?.days_until_loyalty || 0), cancel_text: null, link_text: $i18n.tl.b_read_more, link_link: yGetI18N(the_links.loyalty) });
    } else {
        showWarning({ texts: (reason as string).split('\n'), cancel_text: null });
    }

    return
}

function makeBookingEndTooltip(session: LegacyEventSession, event: LegacyEvent) {
    const info = $el.ICON(UIIcon.CIRCLE_INFO | UIIcon.WEIGHT_SOLID);
    const end_time = event.getBookingEnd(session);
    addTooltip(yInterpolate($i18n.tl.tt_book_before, end_time.formatIn('EEE d MMM HH:mm', tz)), info, { offset: 8, position: UIRelPos.Above });
    return info;
}

export class HomeSessionSchedule extends UIView {
    private _items: HTMLDivElement;
    private _read_more: UIButton;
    private _event: LegacyEvent;
    private _venue: CVenueSceneView;
    private _flow: string;

    constructor(event: LegacyEvent, venue: CVenueSceneView, flow: string) {
        super('div', 'tl-session-schedule');

        this._event = event;
        this._venue = venue;
        this._flow = flow;

        this._read_more = new UIButton({
            kind: 'k-text', title: $i18n.tl.b_more_dates, classes: 'r-more', on_click: () => {
                this.classList.remove('f-collapsed');
            }
        });

        this.ui_add([
            $el.H3('heading', $i18n.tl.td_payment_tickets),
            this._items = $el.DIV('r-items'),
            this._read_more
        ]);

        this.reload();
    }

    reload() {
        const event = this._event;
        const items = this._items;
        let sessions = event.bookable_sessions;
        let availability: Promise<LegacyAvailability[]> | undefined;

        const shouldShowStandbyPopup = (all: LegacyAvailability[]) => {
            for(const s of sessions) {
                const availability = all.find(m => m.id == s.id);
                if(!availability || availability.already || availability.can_book || !availability.can_standby) return;
            }

            return $storage.once('standby_popup_shown');
        }

        if(sessions.length) {
            if(the_login_scope) {
                availability = legacyEventGetAvailability(event.model.id);
                availability.then(all => {
                    if(shouldShowStandbyPopup(all)) {
                        showWarning({
                            title: $i18n.tl.h_standby_first, text: $i18n.tl.w_standby_first,
                            cancel_text: null, link_text: $i18n.tl.l_read_more_here,
                            link_link: 'https://support.abundolive.se/bokning-and-avbokning/hur-fungerar-standby'
                        });
                    } else if(sessions.some(s => s.is_loyalty) && $storage.once('loyalty_popup_shown')) {
                        let message = $i18n.tl.p_loyalty;

                        if(all[0].days_until_loyalty > 0) {
                            if(all.some(a => a.reason == "loyalty_inactive" || a.reason == "loyalty_paused"))
                                message = $i18n.tl.w_cantbook_loyalty_inactive
                            else
                                message = $i18n.tl.w_cantbook_loyalty;
                        }

                        showWarning({ text: yInterpolate(message, the_settings!.loyalty_months, all[0].days_until_loyalty), cancel_text: null, link_text: $i18n.tl.b_read_more, link_link: yGetI18N(the_links.loyalty) });
                    }
                });
            }
        } else { //only past events
            sessions = event.past_sessions;
        }

        items.ui_empty();

        for(let s of sessions) {
            const item = $el.DIV('r-item');
            if(s.drop_in)
                item.classList.add('f-dropin');
            if(!legacyIsSessionBookable(s))
                item.classList.add('f-past');

            const dots = new ABAvailabilityDots;

            item.ui_add($el.DIV('r-info', [
                $el.DIV('r-time', [
                    $el.I(legacyPrettySessionTime(s)),
                    makeBookingEndTooltip(s, event)
                ]),
                dots
            ]));

            if(availability) {
                availability.then(all => {
                    const availability = all.find(m => m.id == s.id);
                    if(!availability) return;

                    dots.available = availability.dots;

                    let button_title: UIViewAddSpec;
                    let button_on_click: UIButtonOnClickCallback;
                    let button_classes: string | undefined;

                    if(availability.already) {
                        button_classes = 'ui-tint-reverse';
                        button_title = availability.standby ? $i18n.tl.b_standby : $i18n.tl.b_booked;
                        button_on_click = () => { $location.navigate(['bookings']) };
                    } else if(!availability.can_book && availability.can_standby) {
                        button_title = $i18n.tl.b_standby;
                        button_classes = 'ui-tint-blue';
                        button_on_click = () => cBookingsStandby($id.objectIdToId(s.id), availability.max_standby).then(() => {
                            let text = $i18n.tl.w_standby;
                            if(availability.max_standby == 2)
                                text = $i18n.tl.w_standby_2;
                            else if(availability.max_standby == 1)
                                text = $i18n.tl.w_standby_1;

                            showWarning({ texts: [text, $i18n.tl.w_standby_info], cancel_text: null });
                            this.reload();
                        });
                    } else {
                        if(availability.reason == 'paused_subs' && availability.dots == 0) {
                            button_title = $i18n.tl.b_standby;
                            button_classes = 'm-hollow';
                        } else if(availability.reason == 'loyalty' || availability.reason == 'loyalty_inactive' || availability.reason == 'loyalty_paused') {
                            button_title = $i18n.tl.b_loyalty_info;
                            button_classes = 'ui-tint-gray';
                        } else {
                            button_title = $i18n.tl.b_book;
                            button_classes = 'ui-tint-blue';
                        }

                        if(availability.can_book) {
                            button_on_click = () => {
                                new HomeBookDialog(event, this._venue, s, this._flow, availability).present().then(() => {
                                    this.reload();
                                });
                            };
                        } else {
                            button_on_click = () => homeDisplayCantBookMessage(availability.reason, event.model.id, availability, this);
                        }
                    }

                    if(s.is_loyalty) {
                        button_title = [$el.DIV('tl-icon m-loyalty'), button_title];
                    }

                    item.ui_add(new UIButton({ title: button_title, kind: 'k-shadow', classes: button_classes, on_click: button_on_click }));
                });
                // } else if($tl.isSessionBookable(s)) {
                //     let button_title: UIViewAddSpec = $i18n.tl.b_book;
                //     let button_on_click = () => { $location.navigate(['signup'], { origin: 'book_button' }) };
                //     let button_classes = 'ui-tint-blue';

                //     if(s.is_loyalty) {
                //         button_title = [$el.DIV('tl-icon m-loyalty'), button_title];
                //     }

                //     item.ui_add(new UIButton({ title: button_title, kind: 'k-shadow', classes: button_classes, on_click: button_on_click }));
            }

            items.ui_add(item);
        }

        if(sessions.length > 6) {
            this.classList.add('f-collapsed');
        }
    }
}

export class HomeImageOverlay extends UIAside {
    private _image: HTMLElement;
    private _images: YId[];
    private _current!: number;

    constructor(images: YId[], current = 0) {
        super('image-overlay');
        const image = this._image = $el.DIV('r-image');
        image.addEventListener('click', () => { this.dismiss(false) });

        this._images = images;
        this.setCurrent(current);
        this.ui_add(image);

        if(images.length > 1) {
            const left = $el.DIV('r-left', $el.ICON(UIIcon.ANGLE_LEFT));
            const right = $el.DIV('r-right', $el.ICON(UIIcon.ANGLE_RIGHT));
            left.addEventListener('click', () => { this.setCurrent(this._current - 1) });
            right.addEventListener('click', () => { this.setCurrent(this._current + 1) });
            this.ui_add([left, right]);
        }

        this.ui_add(new UIButton({ icon: UIIcon.XMARK, on_click: () => { this.dismiss(false) } }));
    }

    setCurrent(current: number) {
        const images = this._images;
        current = current % images.length;
        if(current < 0) current += images.length;
        if(current !== this._current) {
            uiSetBG(this._image, { media: images[current], size: 'contain' });
            this._current = current;
        }
    }
}

function makeReviewDiv(r: CReviewHomeView) {
    return $el.DIV('tl-review', [
        $el.DIV('r-top', [
            $el.ICON(r.rating == 'down' ? UIIcon.THUMBS_DOWN | UIIcon.WEIGHT_SOLID : UIIcon.THUMBS_UP | UIIcon.WEIGHT_SOLID),
            $el.DIV('r-texts', [
                $el.DIV('r-author', r.user_name),
                $el.DIV('r-date', $date(r.created_at).format('MMM yyyy'))
            ])
        ]),
        $el.P('text', r.text),
    ]);
}

export class HomeReviewsScreen extends ABScreen {
    constructor(private _city_slug: string, private _slug: string) {
        super({});
    }

    protected override fillContent(content: UIViewSpec): void {
        const section = $el.DIV('ui-section pad-t-none pad-b-wide', [
            new HomeMenu,
            $el.DIV('s-small')
        ]);

        content.ui_add(section);

        legacyEventByCityAndSlug(this._city_slug, this._slug).then(event => {
            legacyGetEventReviews(event.model.id).then(reviews => {
                section.ui_add($el.DIV('tl-reviews-block', [
                    $el.DIV('r-reviews', reviews.map(makeReviewDiv)),
                    $el.DIV('tl-rating-circle', [$el.SPAN('r-score', (event.rating_score * 100).toFixed(0) + '%'), $el.I(reviews.length + ' ' + $i18n.tl.t_reviews)])
                ]))
            });
        });
    }
}

function fillTopSection(section: HTMLDivElement, event: LegacyEvent, flow: string) {
    const model = event.model;
    const url = event.page_url;

    const share_buttons = $el.DIV('tl-share-buttons', [
        new UIButton({
            kind: 'k-square', classes: 'm-round', icon: UIIcon.BRAND_FACEBOOK, on_click: () => {
                aTrackShare('event', 'facebook', { event: $id.objectIdToId(event.model.id) });
                $analytics.track('Share event', { event_id: event.model.id, event_name: event.name, media: 'Facebook', event_flow: flow });
                $facebook.share(url);
            }, alt: 'Facebook'
        }),
        new UIButton({
            kind: 'k-square', classes: 'm-round', icon: UIIcon.BRAND_TWITTER, on_click: () => {
                aTrackShare('event', 'twitter', { event: $id.objectIdToId(event.model.id) });
                $analytics.track('Share event', { event_id: event.model.id, event_name: event.name, media: 'Twitter', event_flow: flow });
                $twitter.share(url);
            }, alt: 'Twitter'
        }),
        new UIButton({
            kind: 'k-square', classes: 'm-round', icon: UIIcon.ENVELOPE, link: yMakeMailtoLink(undefined, undefined, url), on_click: () => {
                aTrackShare('event', 'email', { event: $id.objectIdToId(event.model.id) });
                $analytics.track('Share event', { event_id: event.model.id, event_name: event.name, media: 'Email', event_flow: flow });
            }, alt: 'Email'
        })
    ])

    const duration = event.duration_text;

    const genres = event.genre_tags.filter(g => g.id != '5e8f992cbf50f572a04e7cc9');
    const genre_chips = genres.length ? genres.slice(0, 2).map(g => {
        const chip = $el.I(cEventTagName(g) + '\u00a0\u00a0\u00a0');
        if(the_login_scope) {
            chip.classList.add('u-clickable');
            chip.addEventListener('click', () => { $location.navigate(['search'], { tag: g.id }) });
        }
        return chip;
    }) : $el.I('Övrigt');

    if(flow == 'past' || (!the_login_scope && event.model.sessions?.length && LegacyEvent.filterPast(event))) {
        const banner = $el.DIV('tl-past-event-banner', [
            $el.DIV('r-text', [
                $el.P('heading', $i18n.tl.t_past_archived_1),
                $el.P('text', [$i18n.tl.t_past_archived_2, $el.BR(), $i18n.tl.t_past_archived_3])
            ]),
            $el.DIV('r-picture')
        ]);

        if(!the_login_scope) {
            const promo = window.ab_signup_promo;

            const standard = window.ab_plans[0];
            const base_price = $format.currency(standard.price[getCountry()]);
            const discounted_price = $format.currency(cPlanDiscountedPrice(standard, promo));

            banner.ui_add(new UIButton({
                title: yInterpolate(yGetI18N(promo.texts.hero_button), base_price, discounted_price), on_click: () => {
                    $location.navigate(['signup'], { origin: 'past_event' })
                }
            }));
        }

        section.ui_add(banner);
    } else {
        section.classList.add('bg-events');
        // uiSetTransition('event-frame', section);
    }

    let picture: UIViewSpec | undefined;
    let info: HTMLElement;

    if(model.videos?.length) {
        model.pictures?.length && uiSetBG(section, { media: model.pictures[0] });
        const video = model.videos[0];

        // if(model.videos[0].is_ppv && !the_user?.subscriptions.length)
        //     this.footer && this.footer.showPPVTerms();

        section.classList.add('tl-play-section');

        picture = section;
        info = $el.DIV('r-info', [
            $el.H1('event-title', event.name),
            duration && $el.DIV(['tl-time-or-place', 't-c-hard'], [$el.ICON(UIIcon.CLOCK | UIIcon.WEIGHT_SOLID), duration]),
            $el.DIV(['tl-time-or-place', 't-c-hard'], [$el.ICON(UIIcon.PLAY | UIIcon.WEIGHT_SOLID), genre_chips]),
        ]);

        section.ui_add([
            $el.DIV('tl-play-filter'),
            $el.DIV('tl-play-header c-dark', [
                info,
                $el.DIV('r-bottom-cap c-natural'),
                share_buttons
            ])
        ]);

        const showUnavailable = () => {
            info.ui_prepend($el.H3('heading', $i18n.tl.t_video_not_available));
        }

        // const showPPV = () => {
        //     const button_title: UIViewAddSpec = yInterpolate($i18n.tl.b_video_buy_amount, video..regular_price/100);
        //     if(the_language == 'en')
        //         button_title = $el.DIV('l-v', [button_title, $el.SPAN('', 'Approx. USD ' + (event.model.regular_price/1000).toFixed(2) )]);

        //     const cover = $el.DIV('r-layer r-cant', [
        //         new UIButton({ title: button_title, on_click: () => { 
        //             $analytics.track('PPV Purchase Button Clicked', event.track_properties);
        //             const c: PurchaseContext = { event: event, video: event.model.videos[0] };
        //             if(the_login_scope)
        //                 new PurchaseDialog(c).present().then($location.reload);
        //             else
        //                 new SignupDialog(c).present().then($location.reload);
        //         }})
        //     ]);


        //     if(date.n) {
        //         if(date.add(2, $time.hour).is_future) {
        //             cover.ui_add($el.H3('heading', $i18n.tl.t_video_starts + ' ' + date.format('EEE d MMM HH:mm')))
        //         } else {
        //             cover.ui_add($el.H3('heading', yInterpolate($i18n.tl.t_video_replay, $time(video.date).format('EEE d MMM HH:mm'))))

        //             if(video.stream) {
        //                 const expires = $time(video.expires);
        //                 if(expires.n)
        //                     cover.ui_add($el.B(yInterpolate($i18n.tl.t_video_until, expires.format('EEE d MMM HH:mm'))))
        //             }
        //         }

        //         if(the_user?.subscriptions.length)
        //             cover.ui_add($el.B($i18n.tl.t_video_live_members))
        //     }

        //     this.ui_add(cover);
        // }

        if(!event.isVideoAvailable(video)) {
            showUnavailable();
        } else if(!the_login_scope && !video.is_open && !video.is_ppv) {
            showUnavailable();
        } else {
            cVideoWatch(model.id, video.id).then(r => {
                if(!r.can_watch) {
                    if(r.reason == 'ended') {
                        showUnavailable();
                    } else {
                        info.ui_prepend([
                            $el.H3('heading', $i18n.tl.h_video_not_active),
                            $el.P('text', $i18n.tl.t_video_not_active),
                            $el.DIV('s-small'),
                            new UIButton({ title: $i18n.tl.b_video_account, classes: 'm-round m-hollow', on_click: () => { $location.navigate(['membership']) } })
                        ])
                    }
                } else if(!r.live) {
                    const date = $time(video.date);
                    if(date.n) {
                        if(date.add(-2, $time.hour).is_future) {
                            info.ui_prepend($el.H3('heading', $i18n.tl.t_video_starts + ' ' + date.format('EEE d MMM HH:mm')));
                        }
                    } else {
                        showUnavailable();
                    }
                } else {
                    info.ui_prepend(new UIButton({
                        title: $i18n.tl.b_start_watching, classes: 'm-round m-hollow', left_icon: UIIcon.PLAY | UIIcon.WEIGHT_SOLID, on_click: () => {
                            $location.navigate(event.player_location, { master_url: r.master_url, position: r.position });
                        }
                    }));
                }
            });
        }
    } else {
        const venue = c_venues.maybe($id.objectIdToId(model.venue as YObjectId))!;
        const venue_text = $el.DIV(['tl-time-or-place', 't-c-soft'], [$el.ICON(UIIcon.LOCATION_DOT | UIIcon.WEIGHT_SOLID), cVenueDisplayName(venue, model.show_scene && model.scene)]);
        if(the_login_scope) {
            venue_text.classList.add('u-clickable');
            venue_text.addEventListener('click', () => { $location.navigate(['search'], { venue: $id.maybeObjectId(model.venue) || '' }) }); // TODO
        }

        if(model.pictures?.length) {
            picture = new UIImageView({ media: model.pictures[0] });
        }

        info = $el.DIV('r-info', [
            $el.H1('event-title', event.name),
            venue_text,
            duration && $el.DIV(['tl-time-or-place', 't-c-soft'], [$el.ICON(UIIcon.CLOCK | UIIcon.WEIGHT_SOLID), duration]),
            $el.DIV('tl-time-or-place t-c-tint', [$el.DIV('tl-icon m-event'), genre_chips]),
            $el.S(),
            share_buttons,
            $el.DIV('r-separator')
        ]);

        section.ui_add($el.DIV('tl-event-header c-natural', [
            picture,
            info
        ]));
    }

    if(xavis_experiments) {
        uiSetTransition('event-info', info);

        if(picture) {
            uiSetTransition('event-image', picture);

            const elem = picture.ui_elem;
            // let transform = 0;
            let padding = 0;

            // TODO: use scroll-driven animation

            onScroll(elem, () => {
                if(!uiIsMedia('m')) return;
                requestAnimationFrame(() => {
                    if(!elem.offsetParent) return;
                    const pos = (elem.offsetParent.getBoundingClientRect().y + elem.offsetTop);
                    const new_padding = Math.max(0, -pos);
                    // const new_transform = Math.min(elem.offsetHeight*0.7, Math.max(0, -pos*0.7 - new_padding));
                    // if(new_transform != transform) {
                    //     transform = new_transform;
                    //     elem.style.setProperty('--tl-event-transform', `${transform}px`);
                    // }
                    if(new_padding != padding) {
                        padding = new_padding;
                        elem.style.paddingTop = `min(100%, ${padding}px)`;
                    }
                });
            });
        }
    }
}

export class HomeEventScreen extends ABScreen {
    private _event?: LegacyEvent;

    constructor(private _city_slug: string, private _slug: string, private _flow: string = '', private _event_list_id?: string) {
        super({});
        $facebook.init();
    }

    protected override async fillContent(content: UIViewSpec) {
        const city_slug = this._city_slug;
        const slug = this._slug;
        const flow = this._flow;

        const event = this._event = await legacyEventByCityAndSlug(city_slug, slug);

        const top_section = $el.DIV('ui-section pad-t-none pad-b-none c-dark', [
            new HomeMenu({ classes: 'c-dark' })
        ]);

        content.ui_add(top_section);

        const properties = event.track_properties;
        properties.event_flow = flow;
        $analytics.track('Viewed event', properties);
        this._fillContent(content, top_section, event, flow);
        aTrackPage('event', { event: $id.objectIdToId(event.model.id) });
    }

    private _fillContent(content: UIViewSpec, top_section: HTMLDivElement, event: LegacyEvent, flow: string) {
        fillTopSection(top_section, event, flow);

        const model = event.model;
        const venue = c_venues.maybe($id.objectIdToId(model.venue as YObjectId))!;
        const pictures = model.pictures || [];

        const read_more = new UIButton({
            kind: 'k-text', title: 'Läs mer', classes: 'r-readmore', on_click: () => {
                left_column.classList.toggle('f-expanded');
            }
        });

        const left_column = $el.DIV('tl-event-col', [
            $el.B(uiMarkdown(event.description)),
            read_more
        ]);

        const right_column = $el.DIV('tl-event-col');

        if(event.active_sessions.length) {
            right_column.ui_add(new HomeSessionSchedule(event, venue, flow));
        }

        const map_url = cVenueStaticMap(venue);
        const links = event.model.links;

        right_column.ui_add([
            map_url && $el.A(cVenueGoogleMaps(venue), [$el.IMG(map_url, undefined, venue.name), $el.DIV('r-icon'), $el.DIV('r-venue', [$el.DIV('r-name', venue.name), $el.DIV('r-address', venue.address)])], 'tl-static-map'),
            links.youtube.split(',').map(l => l.trim()).map(l => l && new $youtube.UIYoutubePlayer({ link: l, audio: true })),
            links.vimeo.split(',').map(l => l.trim()).map(l => l && $vimeo.player(l, 'r-vimeo')),
            links.spotify.split(',').map(l => l.trim()).map(l => l && $spotify.player(l, 'r-spotify')),
            links.soundcloud.split(',').map(l => l.trim()).map(l => l && $soundcloud.player(l, 'r-soundcloud'))
        ]);

        const bottom_section = $el.DIV('ui-section pad-t-none', $el.DIV('tl-event-info', [left_column, right_column]));

        if(pictures.length > 1) {
            const pictures_elem = $el.DIV('tl-event-pictures');
            bottom_section.ui_add(pictures_elem);

            const rows = Math.ceil(pictures.length / 3);
            const over = pictures.length % 3;
            let i = 0;
            for(let j = 0; j < rows; j++) {
                const n = (j == 0 && over > 0) || (j == rows - 1 && over == 1) ? 2 : 3;
                const s = i;

                pictures_elem.ui_add($el.DIV('r-row m-' + n, pictures.slice(i, i + n).map((p, l) => {
                    let iv = new UIImageView({ media: p });
                    iv.ui_elem.addEventListener('click', () => {
                        new HomeImageOverlay(pictures, l + s).present();
                    });
                    return iv;
                })));

                i += n;
            }
        }

        legacyGetEventReviews(model.id).then(reviews => {
            if(reviews.length) {
                bottom_section.ui_add($el.DIV('tl-event-reviews', [
                    $el.DIV('r-top', [
                        $el.DIV('r-title', [$el.ICON(UIIcon.THUMBS_UP | UIIcon.WEIGHT_SOLID), '\u00a0\u00a0' + (event.rating_score * 100).toFixed(0) + '%\u00a0\u00a0\u00B7\u00a0\u00a0' + reviews.length + ' ' + $i18n.tl.t_reviews]),
                        reviews.length > 6 && new UIButton({
                            title: $i18n.tl.t_review_see_more, classes: 'ui-tint-reverse', on_click: () => {
                                $location.navigate(['event', this._city_slug, model.slug, 'reviews']);
                            }
                        })
                    ]),
                    $el.DIV('r-reviews', reviews.slice(0, 6).map(makeReviewDiv)),
                ]))
            }
        });

        content.ui_add(bottom_section);
    }

    override onWillTransitionTo(_screen: UIScreen) {
        return this._event && { event_id: $id.objectIdToId(this._event.model.id), event_list_id: this._event_list_id };
    }
}
